// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyList_container__YZne8","title":"EmptyList_title__2FwwF","action":"EmptyList_action__1CTEN","icon":"EmptyList_icon__1NYHg"};